<template>
    <section>
        <div class="d-flex justify-content-end mb-3 px-3 pt-3">
            <router-link
                to="/company/webhooks/create"
                class="wh-create-btn"
            >
                <i class="fal fa-plus" style="color: #fff !important;"></i>
                {{ $t('companies.webhook.create_one') }}
            </router-link>
        </div>

        <BmvTable
            :columns="tableColumns"
            :data="webhooks"
            :empty-text="$t('companies.webhook.not_found')"
        >
            <template #cell-id="{ row }">
                <span class="wh-id">#{{ row.id }}</span>
            </template>

            <template #cell-name="{ row }">
                <span class="wh-name">{{ row.name }}</span>
            </template>

            <template #cell-url="{ row }">
                <span class="wh-url">{{ row.url }}</span>
            </template>

            <template #cell-actions="{ row }">
                <div class="d-flex align-items-center justify-content-center" style="gap: 6px;">
                    <router-link
                        :to="`/company/webhooks/${row.id}/edit`"
                        class="wh-btn wh-btn--edit"
                    >
                        <i class="fal fa-pen" style="color: #fff !important;"></i>
                    </router-link>
                </div>
            </template>
        </BmvTable>
    </section>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import BmvTable from '@/components/UI/BmvTable'

export default {
    name: 'CompanyWebhooks',
    components: { BmvTable },
    props: {
        webhooks: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            tableColumns: [
                { field: 'id', label: 'ID', width: '60px' },
                { field: 'name', label: this.$t('companies.name'), sortable: true },
                { field: 'url', label: 'URL', sortable: true },
                { field: 'signature_secret', label: this.$t('companies.signature'), sortable: true },
                { field: 'actions', label: this.$t('companies.actions'), width: '80px', align: 'center' }
            ]
        }
    }
}
</script>

<style scoped>
.wh-create-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    background: #0891B2;
    color: #fff;
    border-radius: 9px;
    font-size: 0.82rem;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s;
}

.wh-create-btn:hover {
    background: #0e7490;
    color: #fff;
    text-decoration: none;
    box-shadow: 0 3px 10px rgba(8, 145, 178, 0.25);
}

.wh-id {
    font-size: 0.78rem;
    font-weight: 600;
    color: #94a3b8;
}

.wh-name {
    font-weight: 600;
    color: #0f172a;
}

.wh-url {
    font-size: 0.82rem;
    color: #64748b;
}

.wh-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.2s ease;
}

.wh-btn i {
    font-size: 0.78rem;
}

.wh-btn--edit {
    background: #f59e0b;
}

.wh-btn--edit:hover {
    background: #d97706;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(245, 158, 11, 0.3);
}
</style>
